export default __webpack_public_path__ + "assets/img/logo-mobile-d9320f03202709d4164b2575b80d6fb4.webp";